const mbToBytesMultiplier = 1000000

export const maxImageUploadBytes = 30 * mbToBytesMultiplier
export const maxVideoUploadBytes = 500 * mbToBytesMultiplier

// This needs to be a minimum of 5 mb for Cloudinary to accept it
export const videoChunkSize = 1048576 * 5
